export default {
    pmusers_delete_users: "Eliminar usuarios",
    pmusers_do_you_want_to_delete: "¿Desea Eliminar usuarios?",
    pmusers_users_have_been_removed: "Los usuarios han sido eliminados",
}